import React from "react";
import Snapshot from "./Snapshot";
import SnapshotTable from "./SnapshotTable";
import { useState, useEffect, useRef } from "react";
import ClientSnapshot from "./ClientSnapshot";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import RevenueSnapshot from "./RevenueSnapshot";
import AumSnapshot from "./AumSnapshot";
import { Constants } from "../../../CommonMethhods/Constants";
import Form from "react-bootstrap/Form";
import SalesSnapShot from "./SalesSnapShot";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  LoginResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import MTFBookSnapshot from "./MTFBookSnapshot";
import { Modal } from "react-bootstrap";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function BusinessSnapshot() {
  const storeToken = localStorage.getItem("ssoToken");
  const filterTabsId = [
    "clientSnapshotYearly",
    "clientSnapshotMonthly",
    "clientSnapshotWeekly",
    "clientSnapshotYesterday",
  ];
  const [clientSnapFilter, setClientSnapFilter] = useState("yearly");
  const [revenueSnapshot, setRevenueSnapshot] = useState(null);
  const [aumSnapshot, setAumSnapshot] = useState(null);
  const [salesSnapshot, setSalesSnapshot] = useState(null);
  const [clientSnapshot, setClientSnapshot] = useState(null);
  const [chartRevenueEq, setChartRevenueEq] = useState(null);
  const [chartRevenueFno, setChartRevenueFno] = useState(null);
  const [chartRevenueTotal, setChartRevenueTotal] = useState(null);
  const [chartAumEq, setChartAumEq] = useState(null);
  const [chartAumFno, setChartAumFno] = useState(null);
  const [chartAumTotal, setChartAumTotal] = useState(null);
  const [NotTradedWMargin, setChartClientNotTradedWMargin] = useState(null);
  const [NotTradedWOMargin, setChartClientNotTradedWOMargin] = useState(null);
  const [chartClientTotal, setChartClientTotal] = useState(null);
  const [clientLoader, setClientLoader] = useState(true);
  const [loader, setLoader] = useState(true);
  const [mtfLoader, setMtfLoader] = useState(true);

  const [buttonLoader, setButtonLoader] = useState({
    pdf: false,
    excel: false,
  });
  const [revenueTable, setRevenueTable] = useState();
  const [aumTable, setAumTable] = useState();
  const [salesTable, setSalesTable] = useState({});
  const [clientTable, setClientTable] = useState({});
  const [businessFilter, setBusinessFilter] = useState("Yesterday");
  const [showMTFModal, setShowMTFModal] = useState(false);
  const [mtfBookDashboard, setMtfBookDashboard] = useState([]);

  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [showAumModal, setShowAumModal] = useState(false);
  const [showRevModal, setShowRevModal] = useState(false);
  const [showTurnoverModal, setShowTurnoverModal] = useState(false);

  const [modalDuration, setModalDuration] = useState("yesterday");
  const [aumLoader, setAumLoader] = useState(false);

  const [revModalDuration, setRevModalDuration] = useState("yesterday");
  const [revenueLoader, setRevenueLoader] = useState(false);
  const [salesModalDuration, setSalesModalDuration] = useState("yesterday");
  const [salesLoader, setSalesLoader] = useState(false);



  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    el?.addEventListener("scroll", updateArrows);
    return () => el?.removeEventListener("scroll", updateArrows);
  }, []);

  const scroll = (direction) => {
    const scrollAmount = 300;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const getBuisnessSnapshotDetails = async () => {
    setLoader(true);
    let payloadValue = {
      Duration: businessFilter,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getBuisnessDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.BuisnessSnapshot_URL,
        `"${encPayload}"`,

      );
       let res = ApiResDecrypt(getBuisnessDetails?.data);
      //let res = getBuisnessDetails?.data; 
      
      setRevenueSnapshot(res.data.revenue);
      setAumSnapshot(res.data.aum);
      setSalesSnapshot(res.data.turnover);
      setClientSnapshot(res.data.clients);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getMTFSnapshotDetails = async () => {
    setMtfLoader(true);
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getMTFSnapDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.MTFSnapshot_URL,
        `"${encPayload}"`,
      );
      const resData = ApiResDecrypt(getMTFSnapDetails.data);
      if (resData.status === 0) {
        setMtfBookDashboard(resData.data.mtfBookDashboard);
        setMtfLoader(false);
      }
    } catch (error) {
      console.error("Error getting Snapshot Details", error);
      setMtfLoader(false);
    }
  };

  // api for revenuesnapshot
  const getRevenueTableData = async (viewType = "grid", duration = revModalDuration) => {
    if(viewType === "grid"){
      setRevenueLoader(true);
    }
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      fileType: viewType,
      duration: duration
    };
    let encPayload = AESEncryption(payloadValue);
    
    try {
      const getRevenueSnapshotDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.RevenueSnapshot_URL,
        `"${encPayload}"`,
        
      );
      const response = ApiResDecrypt(getRevenueSnapshotDetails?.data);
      if (response?.status === 0) {
        
        if (viewType === "grid") {
          setRevenueTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setRevenueTable()
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }

    } catch (error) {
      setRevenueTable()
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
      setRevenueLoader(false);
    }
  };

  // api for aumsnapshot
  const getAUM = async (viewType = "grid", duration = modalDuration) => {
    if(viewType === "grid"){
      setAumLoader(true);
    }
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      fileType: viewType,
      duration: duration
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");
    
    
    try {
      const getSnapshotDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.AUMSnapshot_URL,
        `"${encPayload}"`,
      );
      let response = ApiResDecrypt(getSnapshotDetails?.data);
      // const response = getSnapshotDetails?.data;
      console.log(response, "responseAUM");
      
      if (response?.status === 0) {
        
        if (viewType === "grid") {
          setAumTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setAumTable()
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      setAumTable()
      console.log(error);
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
      setAumLoader(false);
    }
  };

  //api for sales

  const getSales = async (viewType = "grid", duration = salesModalDuration) => {
    if(viewType === "grid"){
      setSalesLoader(true);
    }
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      fileType: viewType,
      duration: duration
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValueSales");
    
    try {
      const getSalesSnapshotDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.SaleSnapshot_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getSalesSnapshotDetails?.data);
      if (response?.status === 0) {
        if (viewType === "grid") {
          setSalesTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
      setSalesLoader(false);
    }
  };

  //api for sales

  // clientSnapshot API

  const getClientSnapshotDetails = async () => {
    setClientLoader(true);
    let payloadValue = {
      duration: clientSnapFilter,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getClientSnapshotsDetails = await axiosInstance.post(
        DASHBOARD_DEFAULT.ClientSnapshot_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getClientSnapshotsDetails?.data);
      const responseData = response?.data;
      setClientTable(responseData);
      setClientLoader(false);
      setChartClientNotTradedWMargin(
        responseData.newacquiredclients.nottradedwmargin
      );
      setChartClientNotTradedWOMargin(
        responseData.newacquiredclients.nottradedwomargin
      );
    } catch (error) {
      console.log(error);
      setClientLoader(false);
    }
  };

  // useEffect(() => {
  //   getRevenueTableData();
  //   getAUM();
  // }, []);

  const handleClientSnapFilter = (data) => {
    setClientSnapFilter(data);
  };
  useEffect(() => {
    getClientSnapshotDetails();
  }, [clientSnapFilter]);

  const handleBusinessFilterChange = (e) => {
    if (e.target.value) {
      setBusinessFilter(e.target.value);
    }
  };
  const handleOnClickSnapFileType = (type, snapName) => {
    
    if (snapName === "Revenue") {
      getRevenueTableData(type, revModalDuration);
    } else if (snapName === "AUM") {
      getAUM(type, modalDuration);
    } else if (snapName === "Sales") {
      getSales(type, salesModalDuration);
    }
  };

  useEffect(() => {
    getBuisnessSnapshotDetails();
    // getRevenueTableData("grid");
    // getAUM("grid", modalDuration);
    getSales("grid");
  }, [businessFilter]);

  useEffect(()=>{
    getAUM("grid", modalDuration);
  }, [modalDuration]);

  useEffect(()=>{
    getRevenueTableData("grid", revModalDuration);
  }, [revModalDuration]);

  useEffect(()=>{
    getSales("grid", salesModalDuration)
  }, [salesModalDuration])

  useEffect(() => {
    getMTFSnapshotDetails();
    //getMTFBookDetails("grid");
  }, []);  

  console.log(revenueTable, "revenueTable");
  

  return (
    <>
      <div className="scroll-container">
        {showLeft && (
          <div className="arrow-left rm-left-arr" onClick={() => scroll("left")}>
            <span className="dim">&lt;</span>&lt;
          </div>
        )}
        {showRight && (
          <div className="arrow-right rm-arrow" onClick={() => scroll("right")}>
            &gt;<span className="dim">&gt;</span>
          </div>
        )}
        <div className="card-box bottom-25">
          <div className="card-title">
            <h2>{Constants.BusinessSnapshot}</h2>
            <div className="filter-options">
              {/* <!-- dropdown --> */}
              <div className="dropdown-filter">
                <Form.Select
                  size="lg"
                  aria-label="Default select example"
                  onChange={handleBusinessFilterChange}
                >
                  <option value="Yesterday">{Constants.Yesterday}</option>
                  <option value="Weekly">{Constants.Weekly}</option>
                  <option value="Monthly">{Constants.Monthly}</option>
                  <option value="Yearly">{Constants.Yearly}</option>

                  {/* <option value="Overall">Overall</option> */}
                </Form.Select>
              </div>
            </div>
          </div>
          {/* <!-- Revenue Tab CSS --> */}
          <div
            className="accordion accordion-flush revenue-accordian"
            id="accordionFlushExample"
          >
            <div className="accordion-item">
              <div className="snapshots-horizontal-scroll" ref={scrollRef}>
                <div className="row">
                  <Snapshot
                    title="Revenue Snapshot"
                    dataTarget="#flush-collapseOne"
                    businessFilter={businessFilter}
                    showRevModal={showRevModal}
                    setShowRevModal={setShowRevModal}
                    textfield={"Figures in Lacs & showing for Current"}
                    snapshotData={
                      revenueSnapshot === null || undefined
                        ? true
                        : revenueSnapshot
                    }
                    isActive={true}
                    loader={loader}
                    chartEq={
                      chartRevenueEq === undefined || null ? true : chartRevenueEq
                    }
                    chartFno={
                      chartRevenueFno === undefined || null
                        ? true
                        : chartRevenueFno
                    }
                    chartTotal={
                      chartRevenueTotal === undefined || null
                        ? true
                        : chartRevenueTotal
                    }
                    // onClick={() => setShowRevModal(true)}
                    ChartName1="Equity"
                    ChartName2="Future and Option"
                    titleForGraph="Revenue"
                  />
                  <Snapshot
                    title="AUM Snapshot"
                    businessFilter={businessFilter}
                    showAumModal={showAumModal}
                    setShowAumModal={setShowAumModal}
                    textfield={"Figures in Lacs & showing for Current"}
                    dataTarget="#flush-collapseTwo"
                    snapshotData={
                      aumSnapshot === null || undefined ? true : aumSnapshot
                    }
                    isActive={true}
                    chartFno={
                      chartAumFno === undefined || null ? true : chartAumFno
                    }
                    chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                    chartTotal={
                      chartAumTotal === undefined || null ? true : chartAumTotal
                    }
                    loader={loader}
                    // onClick={() => setShowAumModal(true)}
                    ChartName1="Equity"
                    ChartName2="Future and Option"
                    titleForGraph="AUM"
                  />
                  <Snapshot
                    // title="Sales Snapshot"
                    title="Turnover Report"
                    businessFilter={businessFilter}
                    showTurnoverModal={showTurnoverModal}
                    setShowTurnoverModal={setShowTurnoverModal}
                    textfield={"Figures in Lacs & showing for Current"}
                    dataTarget="#flush-collapseThree"
                    snapshotData={
                      salesSnapshot === null || undefined ? true : salesSnapshot
                    }
                    // chartFno={
                    //   chartAumFno === undefined || null ? true : chartAumFno
                    // }
                    // chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                    // chartTotal={
                    //   chartAumTotal === undefined || null ? true : chartAumTotal
                    // }
                    // onClick={() => setShowTurnoverModal(true)}
                    loader={loader}
                    isActive={true}
                    ChartName1="Equity"
                    ChartName2="Future and Option"
                    titleForGraph="AUM"
                  />
                  <Snapshot
                    title="Client Snapshot"
                    businessFilter={businessFilter}
                    textfield={"Number showing for Current"}
                    dataTarget="#flush-collapseFour"
                    snapshotData={
                      clientSnapshot === null || undefined ? true : clientSnapshot
                    }
                    isActive={false}
                    chartEq={
                      NotTradedWMargin === undefined || null
                        ? true
                        : NotTradedWMargin
                    }
                    chartFno={
                      NotTradedWOMargin === undefined || null
                        ? true
                        : NotTradedWOMargin
                    }
                    chartTotal={
                      (NotTradedWMargin === undefined || null
                        ? true
                        : NotTradedWMargin) +
                      (NotTradedWOMargin === undefined || null
                        ? true
                        : NotTradedWOMargin)
                    }
                    ChartName1="Not Traded w/ Margin"
                    ChartName2="Not Traded w/o Margin"
                    loader={loader}
                    titleForGraph="Client"
                  />

                  <Snapshot
                    title="MTF Book"
                    showMTFModal={showMTFModal}
                    setShowMTFModal={setShowMTFModal}
                    businessFilter={businessFilter}
                    textfield={"Number showing for Current Year"}
                    snapshotData={
                      mtfBookDashboard === null || undefined
                        ? true
                        : mtfBookDashboard[0]
                    }
                    isActive={true}
                    loader={mtfLoader}
                    titleForGraph="MTF"
                  />
                </div>
              </div>

              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-parent="#accordionFlushExample"
              >
                {/* <RevenueSnapshot
                  title="Revenue Snapshot"
                  revenueTableData={
                    revenueTable === undefined || null ? true : revenueTable
                  }
                  handleOnClickSnapFileType={handleOnClickSnapFileType}
                  buttonLoader={buttonLoader}
                /> */}
              </div>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-parent="#accordionFlushExample"
              >
                {/* <AumSnapshot
                  title="AUM Snapshot"
                  revenueTableData={
                    aumTable === undefined || null ? true : aumTable
                  }
                  handleOnClickSnapFileType={handleOnClickSnapFileType}
                  buttonLoader={buttonLoader}
                /> */}
              </div>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-parent="#accordionFlushExample"
              >
                {/* <SalesSnapShot
                  // title="Sales Snapshot"
                  title="Turnover Report"
                  revenueTableData={
                    salesTable === undefined || null ? true : salesTable
                  }
                  handleOnClickSnapFileType={handleOnClickSnapFileType}
                  buttonLoader={buttonLoader}
                /> */}
              </div>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-parent="#accordionFlushExample"
              >
                <ClientSnapshot
                  loaderClient={clientLoader}
                  title="Client Snapshot"
                  filterTabsId={filterTabsId}
                  clientTableData={clientTable}
                  handleClientSnapFilter={handleClientSnapFilter}
                  getClientSnapshotDetails={getClientSnapshotDetails}
                  buttonLoader={buttonLoader}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showMTFModal}
        onHide={() => setShowMTFModal(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="mtf-modal-popup setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>MTF Book</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowMTFModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <MTFBookSnapshot
            buttonLoader={buttonLoader}
            setButtonLoader={setButtonLoader}
            storeToken={storeToken}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showAumModal}
        // onHide={() => setShowAumModal(false)}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
        className="aum-modal-popup setting-model aum-modal"
      >

        <Modal.Body>
          <AumSnapshot
          setShowAumModal={setShowAumModal}
            title="AUM Snapshot"
            revenueTableData={aumTable}
            handleOnClickSnapFileType={handleOnClickSnapFileType}
            buttonLoader={buttonLoader}
            setModalDuration = {setModalDuration}
            modalDuration={modalDuration}
            aumLoader={aumLoader}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showRevModal}
        // onHide={() => setShowRevModal(false)}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
        className="aum-modal-popup setting-model rev-modal"
      >

        <Modal.Body>
          <RevenueSnapshot
            setShowRevModal={setShowRevModal}
            title="Revenue Snapshot"
            revenueTableData={revenueTable}
            handleOnClickSnapFileType={handleOnClickSnapFileType}
            buttonLoader={buttonLoader}
            setRevModalDuration={setRevModalDuration}
            revModalDuration={revModalDuration}
            revenueLoader={revenueLoader}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showTurnoverModal}
        // onHide={() => setShowRevModal(false)}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
        className="aum-modal-popup setting-model turnover-modal"
      >

        <Modal.Body>
          <SalesSnapShot
            setShowTurnoverModal={setShowTurnoverModal}
            title="Turnover Snapshot"
            revenueTableData={salesTable}
            handleOnClickSnapFileType={handleOnClickSnapFileType}
            buttonLoader={buttonLoader}
            setSalesModalDuration={setSalesModalDuration}
            salesModalDuration={salesModalDuration}
            salesLoader={salesLoader}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BusinessSnapshot;
